import { InitOptions } from 'i18next';

export default {
  supportedLngs: ['en', 'hi', 'fr', 'de', 'it', 'es', 'nl', 'ru'],
  fallbackLng: 'en',
  defaultNS: 'common',
} satisfies InitOptions;
